import { useMemo } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useCrumb } from "./CrumbContext";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { useBaseRoutePathContext } from "@poseidon/utils/base-route-path";

const replaceVars = (template, vars) => {
  return template.replace(/\{[^}]+}/g, (paramStr) => {
    const param = paramStr.replace(/^\{|}$/g, "");
    return vars[param];
  });
};

export default function OutletWithCrumb({ to: toRaw, docRef: refRaw, crumb }) {
  const params = useParams();
  const { route: baseRoutePath } = useBaseRoutePathContext();
  const crumbDef = useMemo(() => {
    const to = baseRoutePath + replaceVars(toRaw, params);
    const docRef = replaceVars(refRaw, params);
    return {
      to,
      Component: () => <WithDoc docRef={docRef} Component={crumb} />,
    };
  }, [params, toRaw, refRaw, crumb, baseRoutePath]);

  useCrumb(baseRoutePath + toRaw, crumbDef);

  return <Outlet />;
}
